export enum ChannelAttributesCode {
  SAFETY_STOCK = "SAFETY_STOCK",
  BC_CHANNEL = "BC_CHANNEL",
  SHOPIFY_SETTINGS = "SHOPIFY_SETTINGS",
  WOOCOMMERCE_DELIVERY = "WOOCOMMERCE_DELIVERY",
  ORDER_INGESTION = "ORDER_INGESTION",
  AMAZON_SETTINGS = "AMAZON_SETTINGS_CODE",
}
